<template lang="pug">
    RouterLink#companion-portrait-card(:to="redirectTo")
      .flex-container-main
        .flex-item
          .cover-art-container
            img.is-square(:src="previewImage" :alt="'Text'" style="height: 100%;")
        .custom-content
          .flex-item
            WtTitle {{ partTitle }}
          .flex-item
            .icon-with-text-container
              WtSvgIcon(icon="companion/guide_icon" width="20px" height="20px")
              span.mb-1 {{ numberOfGuides }} guides
</template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
export default {
  name: "CompanionTopicCard",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    redirectTo: { type: String, required: true },
    id: { type: String, default: "" },
    partId: { type: String, default: "" },
    partTitle: { type: String, default: "" },
    previewImage: { type: String, default: "" },
    numberOfGuides: { type: Number, default: 0 }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
#companion-portrait-card {
  border: 1px solid #d9dbe0;
  border-radius: 0.75rem;
  display: flex !important;
  justify-content: space-between !important;
  font-family: Manrope !important;
  font-weight: 600 !important;
  background-color: white !important;
  max-width: 222px !important;
}

.flex-container-main {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
  padding: 16px !important;
}
.custom-content {
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
}

.cover-art-container {
  min-width: 190px !important;
  height: 96px !important;
}

.cover-art-container img {
  border-radius: 8px !important;
  width: 100% !important;
  height: 100% !important;
}

.title {
  font-size: 16px !important;
  font-weight: 600 !important;
  font-family: Manrope !important;
  font-style: normal !important;
  line-height: 20px !important;
  color: #1b1d20;
  padding-bottom: 0rem !important;
}
.icon-with-text-container {
  display: flex !important;
  align-items: center !important;
  padding: auto !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 18px !important;
  font-family: Manrope !important;
  font-style: normal !important;
  color: #5a5c60 !important;
}

.icon-with-text-container span {
  margin-left: 0.25rem !important;
}
@media screen and (max-width: 768px) {
  .tile.is-parent {
    padding: 1rem 1rem 1rem 1rem !important;
  }
  .cover-art-container {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
